import "../styles/Home.css";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="hero">

      <div className="hero-content">

        <h1>Little Lemon 🍋</h1>

        <p className="tagline">
          Fresh Flavors • Authentic Taste • Memorable Experience
        </p>

        <p className="quote">
          “Where every flavor tells a story and every meal becomes a memory.”
        </p>

        <Link to="/booking">
          <button className="hero-button">
            Reserve a Table
          </button>
        </Link>

      </div>

    </div>
  );
}

export default Home;